/**
 * Functionality for tax exempt checkout option.
 *
 * This is used on the cart page and account page.
 */
(function() {
  var cartComponent = document.getElementById('tax-exemption-component');
  var accountMessage = document.getElementById('tax-exemption-account-status');

  // Initialize on either cart or account.
  function initializeTaxExemptionComponent() {
    var checkbox = document.getElementById('enable-tax-exemption');
    var links = cartComponent.querySelectorAll('[data-tax-exemption-form]');
    var message = cartComponent.querySelector('[data-tax-exemption-message]');

    if (links) {
      initializeTaxExemptionFormLinks(links);
    }

    if (checkbox && message) {
      initializeCartToggle(checkbox, message);
    }
  }

  // Initializes links to forms as Typeform popups.
  function initializeTaxExemptionFormLinks(links) {
    links.forEach(function(link) {
      var formId = link.dataset.taxExemptionForm;
      var fields = {
        customer_id: link.dataset.taxExemptionCustomerId,
        customer_email: link.dataset.taxExemptionCustomerEmail,
        url: window.location.href
      }
      var popup = window.tf.createPopup(formId, {
        size: 80,
        opacity: 100,
        hidden: fields
      })
      link.onclick = function() {
        popup.toggle();
        return false;
      };
    });
  }

  // Initializes the cart checkbox toggle.
  function initializeCartToggle(checkbox, message) {
    var persist = Boolean(typeof window.localStorage !== 'undefined');

    var toggleTaxExemptState = function(isChecked) {
      if (isChecked) {
        message.removeAttribute('hidden');
      }
      else {
        message.setAttribute('hidden', true);
      }
    }

    checkbox.addEventListener('change', function() {
      var isChecked = Boolean(checkbox.checked);
      toggleTaxExemptState(isChecked);
      if (persist) {
        localStorage.setItem('customer_tax_exemption_enabled', isChecked ? 'yes' : 'no');
      }
    });

    // Restore the user's previous checkbox state.
    if (persist) {
      var taxExemptWasEnabled = localStorage.getItem('customer_tax_exemption_enabled');
      if (taxExemptWasEnabled === 'yes') {
        checkbox.checked = true;
        toggleTaxExemptState(true);
      }
    }
  }

  // Cart page only.
  if (cartComponent) {
    document.addEventListener('DOMContentLoaded', initializeTaxExemptionComponent);
    document.addEventListener('cart:rerendered', initializeTaxExemptionComponent);
    document.addEventListener('DOMContentLoaded', handleTaxExemptionFormRedirect);
  }

  // Account page only.
  if (accountMessage) {
    document.addEventListener('DOMContentLoaded', function() {
      var links = accountMessage.querySelectorAll('[data-tax-exemption-form]');

      if (links) {
        initializeTaxExemptionFormLinks(links);
      }

      if ((typeof window.localStorage !== 'undefined') && (localStorage.getItem('customer_tax_exemption_enabled') === 'yes')) {
        accountMessage.removeAttribute('hidden');
      }
    });
  }

  /**
   * Renders the modal the user lands on from Typeform.
   *
   * Because there's a delay after submitting the form,
   * we poll for the customer's tax exempt status.
   */
  function handleTaxExemptionFormRedirect() {
    var url = new URL(window.location.href);
    var redirect = url.searchParams.get('redirect');
    if (!redirect || redirect !== 'tax-exemption-form' || !window.fetch) return;

    var modal = document.getElementById('modal-tax-exemption-form-redirect');
    modal.setAttribute('aria-hidden', false);

    var setSuccessState = function() {
      modal.querySelector('[data-loading-content]').setAttribute('hidden', true);
      modal.querySelector('[data-success-content]').removeAttribute('hidden');
    }

    var setErrorState = function() {
      modal.querySelector('[data-loading-content]').setAttribute('hidden', true);
      modal.querySelector('[data-error-content]').removeAttribute('hidden');
    }

    var timer = 0;
    var intervalSeconds = 5;
    var maxSeconds = 120
    var statusUrl = modal.dataset.statusUrl;

    // Polls for customer status using a special template.
    // @see cart-template.liquid
    var interval = setInterval(function() {
      try {
        window.fetch(statusUrl)
          .then(function(response) {
            return response.json();
          })
          .then(function(status) {
            if (status && status.tax_exempt) {
              clearInterval(interval);
              setSuccessState();
            }
          });
      }
      catch (error) {
        clearInterval(interval);
        setErrorState();
      }

      timer += intervalSeconds;

      // Time limit was hit.
      if (timer >= maxSeconds) {
        clearInterval(interval);
        setErrorState();
      }

    }, intervalSeconds * 1000);
  };
})();


